import api from '@/utils/api';
import { getCredentials } from '@/utils/cognito';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
const AxiosErrorHandleProvider = ({
  children
}) => {
  const router = useRouter();
  useEffect(() => {
    // axiosの共通エラーハンドリング記述
    api.interceptors.response.use(response => response, error => {
      const statusCode = error.response?.status;
      // ログインしてなければ
      if (getCredentials() === null) {
        router.push('/account/login');
      } else if (statusCode !== 0) {
        router.push({
          pathname: '/error',
          query: {
            statusCode
          }
        });
      }
      return Promise.reject(error.response?.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div>{children}</div>;
};
export default AxiosErrorHandleProvider;